import { createAsyncThunk } from '@reduxjs/toolkit'
import { authApi } from '@/store/api/authApi'
import { profileApi } from '@/store/api/profileApi'
import { paymentApi } from '@/store/api/paymentApi'
import { logout } from '@/store/slices/authSlice'
import { disconnectPlayerSocket } from '@/store/socket/player-socket'

export const logoutUser = createAsyncThunk('auth/logoutUser', async (_, { dispatch }) => {
	try {
		await dispatch(authApi.endpoints.revokeToken.initiate()).unwrap()
	} finally {
		disconnectPlayerSocket()
		dispatch(logout())
		dispatch(authApi.util.resetApiState())
		dispatch(profileApi.util.resetApiState())
		dispatch(paymentApi.util.resetApiState())
	}
})
